(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shf-landing-body"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFaq = (root) => {
      if (root.dataset.shfFaqReady === 'true') return;
      root.dataset.shfFaqReady = 'true';
      const items = Array.from(root.querySelectorAll('[data-shf-faq-item]'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
      const input = root.querySelector('[data-shf-faq-search]');
      const empty = root.querySelector('[data-shf-faq-empty]');
      if (!input) return;
      input.addEventListener('keydown', (event) => {
        if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.select();
        }
      });
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let visibleCount = 0;
        items.forEach((item) => {
          const matches = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });
        if (empty) empty.hidden = visibleCount !== 0;
      });
    };
    const initializeAllFaqs = (scope) => {
      scope.querySelectorAll('[data-shf-faq]').forEach(initializeFaq);
    };
    initializeAllFaqs(document);
    document.addEventListener('shopify:section:load', (event) => initializeAllFaqs(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shf-landing-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFaq = (root) => {
      if (root.dataset.shfFaqReady === 'true') return;
      root.dataset.shfFaqReady = 'true';

      const items = Array.from(root.querySelectorAll('[data-shf-faq-item]'));

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });

      const input = root.querySelector('[data-shf-faq-search]');
      const empty = root.querySelector('[data-shf-faq-empty]');
      if (!input) return;

      input.addEventListener('keydown', (event) => {
        if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.select();
        }
      });

      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const matches = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        if (empty) empty.hidden = visibleCount !== 0;
      });
    };

    const initializeAllFaqs = (scope) => {
      scope.querySelectorAll('[data-shf-faq]').forEach(initializeFaq);
    };

    initializeAllFaqs(document);
    document.addEventListener('shopify:section:load', (event) => initializeAllFaqs(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
